angular.module('tgaAdmin').controller('HubGamesController', [
  '$scope',
  '$state',
  '$location',
  '$timeout',
  '$uibModal',
  'hubService',
  'flashService',
  'modalService',
  'gameService',
  'urlService',
  'tagService',
  '$log',
  '$translate',
  'settingsService',
  function (
    $scope,
    $state,
    $location,
    $timeout,
    $uibModal,
    hubService,
    flashService,
    modalService,
    gameService,
    urlService,
    tagService,
    $log,
    $translate,
    settingsService,
  ) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      alerts: [],
      activities: [],
      activity_icons: [
        {
          criteria: (item) => item.start_date || item.end_date,
          class: (item) => ({
            'text-success': moment.utc(item.start_date).local() < moment(),
            'text-danger': moment.utc(item.end_date).local() < moment(),
          }),
          icon: 'schedule',
          label: 'Activity has start or end date.',
        },
        {
          criteria: (item) => item.is_featured,
          class: () => ({
            'text-warning': true,
          }),
          icon: 'star',
          label: 'Activity is featured.',
        },
        {
          criteria: (item) => item.is_locked,
          class: () => ({
            'text-primary': true,
          }),
          icon: 'lock',
          label: 'Activity is locked by another activity.',
        },
      ],
      hubId: $state.params.hub_id || null,
      url: urlService.composeProtocolHostPort($location),
      tags: [],
      settings: {},
    };

    $scope.sortableOptions = {
      items: 'tr',
      containment: '.box-body',
      revert: false,
      forcePlaceholderSize: true,
      tolerance: 'pointer',
      cursor: 'move',
      handle: '.handle',
      placeholder: 'ui-sortable-placeholder',
      helper(event, element) {
        element.children().each(function () {
          $(this).width($(this).width());
        });
        return element.clone().appendTo('body');
      },
      scroll: true,
      start(e, ui) {
        ui.placeholder.height(ui.item.height());
      },
    };

    $scope.viewmodel = {
      hub_id: $scope.data.hubId,
      activities: [],
    };

    $scope.initialize = function () {
      $scope.loading = true;

      hubService
        .getHub($scope.data.hubId)
        .then((hub) => {
          $scope.viewmodel = { ...$scope.viewmodel, ...hub };
          $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Activities`;
          $scope.loading = false;
        })
        .catch((error) => {
          $log.log(error);
        });

      $scope.actions.getGames();

      tagService.getTags().then((tags) => {
        $scope.data.tags = tags;
      });

      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
      });
    };

    $scope.actions = {
      totalFeatured() {
        // Count up how many are selected now.
        let selected = 0;
        $scope.viewmodel.activities.forEach((act) => {
          if (act.is_featured) {
            selected++;
          }
        });
        return selected;
      },
      getGames() {
        $scope.loadingActivities = true;
        gameService.getAllGames({ exclude_extra_data: true }).then((games) => {
          games.map((game) => {
            game.activity_type = 'game';
            game.activity_type_name = 'Games';
            game.tags = game.tags ? game.tags.split(', ') : null; // tags needs to be an array
            return game;
          });
          $scope.data.activities = games;

          hubService.getJourneys({ hub_id: $scope.data.hubId }).then((journeys) => {
            journeys.map((journey) => {
              journey.activity_type = 'journey';
              journey.activity_type_name = 'Journeys';
              return journey;
            });
            $scope.data.activities = journeys.concat($scope.data.activities);

            hubService.getMissions({ hub_id: $scope.data.hubId }).then((missions) => {
              missions.map((mission) => {
                mission.activity_type = 'mission';
                mission.activity_type_name = 'Missions';
                return mission;
              });
              $scope.data.activities = missions.concat($scope.data.activities);
              $scope.loadingActivities = false;
            });
          });
        });
      },
      removeActivity(activity) {
        activity.deleted = true;
        $scope.actions.updateLockedStatus(activity.course_group_id);
      },
      addActivity() {
        $scope.hubForm.selected_activity.$setValidity('required', true);

        const gameIdToCheck = $scope.viewmodel.selected_activity.game_id;
        let inList = false;

        if (gameIdToCheck) {
          // make sure there is no duplicate games
          inList = $scope.viewmodel.activities.some((activity) => {
            if (activity.game_id === gameIdToCheck) {
              activity.deleted = false;
            }

            return activity.game_id === gameIdToCheck;
          });
        }

        const journeyIdToCheck = $scope.viewmodel.selected_activity.course_group_id;

        if (journeyIdToCheck) {
          // make sure there is no duplicate journeys
          inList = $scope.viewmodel.activities.some((activity) => {
            if (activity.course_group_id === journeyIdToCheck) {
              activity.deleted = false;
            }

            return activity.course_group_id === journeyIdToCheck;
          });
        }

        if (!inList) {
          $scope.viewmodel.selected_activity.show_leaderboard = true;
          $scope.viewmodel.selected_activity.show_challenge = true;
          $scope.viewmodel.selected_activity.show_solo = true;
          $scope.viewmodel.activities.unshift($scope.viewmodel.selected_activity);
        }

        $scope.viewmodel.selected_activity = null;
      },
      notAdded(item) {
        const added = $scope.viewmodel.activities.filter(
          (activity) =>
            !activity.deleted &&
            ((activity.activity_type === 'game' && activity.game_id === item.game_id) ||
              (activity.activity_type === 'journey' && activity.course_group_id === item.course_group_id) ||
              (activity.activity_type === 'mission' && activity.course_group_id === item.course_group_id)),
        );

        return added.length === 0;
      },
      updateLockedStatus(activityCourseGroupId) {
        $scope.viewmodel.activities.forEach((activity) => {
          if (activity.locked_by_course_group_id === activityCourseGroupId) {
            activity.is_locked = false;
            activity.locked_by_course_group_id = null;
          }
        });
      },
      gameSettings(game) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-hub-game-settings.html',
            controller: 'HubGameSettingsModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  game,
                  items_featured: $scope.actions.totalFeatured(),
                  hubId: $scope.data.hubId,
                  activities: $scope.viewmodel.activities,
                };
              },
            },
          })
          .result.then((response) => {
            game.tile_image = response.tile_image;
            game.tile_color = response.tile_color;
            game.banner_image = response.banner_image;
            game.show_leaderboard = response.show_leaderboard;
            game.show_challenge = response.show_challenge;
            game.show_solo = response.show_solo;
            game.scorm_game_length = response.scorm_game_length;
            game.start_date = response.start_date;
            game.coming_soon = response.coming_soon;
            game.end_date = response.end_date;
            game.is_featured = response.is_featured;
            game.featured_text = response.featured_text;
            game.is_locked = response.is_locked;
            game.locked_by_course_group_id = response.locked_by_course_group_id;

            // OAT 219/220: Allow editing activity name and file for pdf and scorm.
            const isScorm = game.activity_type === 'game' && game.ext_game_id !== null;
            const isPdf = game.activity_type === 'pdf';
            const isVideo = game.activity_type === 'video';
            const isImage = game.activity_type === 'image';
            const isLink = game.activity_type === 'link';
            const isAudio = game.activity_type === 'audio';
            // Allow changing the name for these items.
            if ((isVideo || isImage || isLink || isPdf || isScorm || isAudio) && response.name !== game.name) {
              game.name = response.name;
            }
            // Allow a new PDF/Image/Video upload to replace the existing one (scorm game is updated by modal)
            if ((isVideo || isImage || isPdf || isLink || isAudio) && response.data !== null) {
              // Endpoint will handle upload to s3 and return a static url.
              game.data = response.data;
            }
            // Allow a new Link
            if (isLink && response.data_type !== null) {
              // Endpoint will handle upload to s3 and return a static url.
              game.data_type = response.data_type;
            }

            $scope.actions.submit($scope.hubForm);
          })
          .catch(angular.noop);
      },
      playerLists(game) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-hub-game-player-lists.html',
            controller: 'HubGamePlayerListsModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  game,
                };
              },
            },
          })
          .result.then((response) => {
            game.player_lists = response.player_lists;
            $scope.actions.submit($scope.hubForm);
          })
          .catch(angular.noop);
      },
      addCustomField(game) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-custom-field.html',
            controller: 'CustomFieldModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  game_id: game.game_id,
                  type: 'dropdown',
                  is_external: game.is_external,
                };
              },
            },
          })
          .result.then((custom_field) => {
            game.team_field_id = custom_field.custom_field_id;
            game.team_field = custom_field;
          })
          .catch(angular.noop);
      },
      uploadScorm() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-scorm-upload.html',
            controller: 'ScormUploadController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  hubId: $scope.data.hubId,
                  game_id: $scope.data.game_id,
                  items_featured: $scope.actions.totalFeatured(),
                };
              },
            },
          })
          .result.then((response) => {
            $scope.viewmodel.activities.unshift(response);
            $scope.actions.submit($scope.hubForm);
          })
          .catch(angular.noop);
      },
      addTask() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-add-task-activity.html',
            controller: 'HubAddTaskActivityController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  hubId: $scope.data.hubId,
                  items_featured: $scope.actions.totalFeatured(),
                };
              },
            },
          })
          .result.then((response) => {
            $scope.viewmodel.activities.unshift(response);
            $scope.actions.submit($scope.hubForm);
          })
          .catch(angular.noop);
      },
      copyUrl() {
        const url = `${$scope.data.url}/hub/${$scope.viewmodel.slug}`;

        return url;
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      submit(form) {
        $scope.submitted = true;

        $scope.data.alerts = [];

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;
        $scope.loading = true;

        hubService
          .updateHub($scope.viewmodel)
          .then(
            () => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade updated.', 'success');
              $scope.initialize();
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            },
          )
          .finally(() => {
            $scope.processing = false;
            $scope.loading = false;
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }

        $scope.timer = $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, 5000);
      },
      addTag(tag) {
        $scope.data.tags.push(tag);
        $scope.data.tags = _.uniq($scope.data.tags).sort();
      },
    };

    $scope.initialize();
  },
]);
